import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../api/client";
import { BankBox } from "../components/BankBox";
import { PRICING } from "../../shared/constants";

interface Invoice {
  id: string;
  kind: "initial" | "monthly" | "credit_charge";
  amount_total: number;
  status: "unpaid" | "paid" | "canceled";
  created_at: string;
}

const yen = (value: number) => `${value.toLocaleString("ja-JP")}円`;

export function InitialPaymentPage() {
  const [invoice, setInvoice] = useState<Invoice | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<{ invoices: Invoice[] }>("/api/cases/invoices")
      .then((res) => {
        setInvoice(
          res.invoices.find((item) => item.kind === "initial" && item.status === "unpaid") ??
          res.invoices.find((item) => item.kind === "initial") ??
          null,
        );
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-center">読み込み中...</div>;

  const amount = invoice?.amount_total ?? PRICING.initialFee;
  const paid = invoice?.status === "paid";

  return (
    <section className="lp-page lp-payment-page">
      <div className="lp-payment-hero lp-card">
        <span className="lp-section-kicker">START</span>
        <h1>最初に初期構築費用のお振込みをお願いします</h1>
        <p>
          LegalPagesでは、初期構築費用 {yen(amount)} の入金確認後に、
          ヒアリング、キーワード設計、素材管理、ページ設計へ進みます。
        </p>
        <div className="lp-payment-amount">
          <span>お振込み金額</span>
          <strong>{yen(amount)}</strong>
        </div>
      </div>

      {paid ? (
        <div className="alert alert-info">
          入金確認済みです。画面を更新してもヒアリングへ進めない場合は、サポートへご連絡ください。
        </div>
      ) : (
        <div className="lp-payment-grid">
          <div className="lp-card">
            <h2>振込先</h2>
            <BankBox />
            <p className="muted small">
              振込手数料はお客様のご負担となります。入金確認は運営が手動で行い、確認後にこの画面から次のステップへ進めます。
            </p>
          </div>
          <div className="lp-card">
            <h2>入金後の流れ</h2>
            <ol className="lp-simple-steps">
              <li>上記口座へ {yen(amount)} をお振込みください。</li>
              <li>運営が入金を確認します。</li>
              <li>確認後、AIチャットヒアリングを開始できます。</li>
            </ol>
            <p className="muted small">
              すでにお振込み済みの場合は、反映まで少しお待ちください。
            </p>
            <a className="btn btn-ghost" href="mailto:ikko.teramoto@pascaline.jp">
              サポートに連絡する
            </a>
          </div>
        </div>
      )}

      <div className="lp-payment-footer">
        <Link to="/terms">利用規約</Link>
        <Link to="/tokushoho">特定商取引法に基づく表記</Link>
      </div>
    </section>
  );
}
